import { Routes } from '@angular/router';
import { LmsModulesComponent } from './lms-modules/lms-modules.component';
import { SessionDetailesComponent } from './lms-modules/session-detailes/session-detailes.component';
import { CertificatesComponent } from './certificates/certificates.component';
import { AlumniComponent } from './alumni/alumni.component';
import { AssignmentDetailComponent } from './lms-modules/assignment-detail/assignment-detail.component';

export const lmsEndUserRoutes: Routes = [
  { path: 'lms/modules', component: LmsModulesComponent },
  { path: 'lms/modules/session/:id', component: SessionDetailesComponent },
  { path: 'lms/modules/assignments/:id', component: AssignmentDetailComponent },
  { path: 'lms/certificates', component: CertificatesComponent },
  { path: 'lms/alumni', component: AlumniComponent },
]

